import ugcAnalytics from './ugcAnalytics';
import importAnalytics from './importAnalytics';
import layersAnalytics from './layersAnalytics';
import collectionsAnalytics from './collectionsAnalytics';
import mapWidgetAnalytics from './mapWidgetAnalytics';
import revenueAnalytics from './revenueAnalytics';
import shareAnalytics from './shareAnalytics';

export default {
  ...ugcAnalytics,
  ...importAnalytics,
  ...layersAnalytics,
  ...collectionsAnalytics,
  ...mapWidgetAnalytics,
  ...revenueAnalytics,
  ...shareAnalytics
};